export default "__VITE_ASSET__BpZgv55u__"